export * from "./configIframe";
export * from "./InscritoPrivado";